import { cn } from "@/utils/cn";
import { IonSpinner } from "@ionic/react";

const spinnerSizeClass = "w-24 h-24";

export const LoadingSpinner = () => {
  return (
    <div className={cn(spinnerSizeClass, "relative")}>
      <div
        className={cn(
          "absolute inset-0 border-6 border-gray-100 rounded-full m-1.5",
        )}
      />
      <IonSpinner
        name="crescent"
        className={cn("w-full h-full absolute inset-0", spinnerSizeClass)}
        color="primary"
      />
    </div>
  );
};
